import { useEffect, useState, useRef, useMemo } from 'react';
import { Card, Row, Col, Form, Input, DatePicker, Button, Steps, message, Select } from 'antd';
import { useStepsForm } from 'sunflower-antd';
import { headerStyle, rowStyle } from 'shared/styles/baseStyle';
import  EndPoints from 'shared/endPoints/EndPoints.json';
import { useHistory, useLocation } from "react-router-dom";
import disableSpecificDates from 'shared/utils/rangePickerUtils';
import  Validations from 'shared/validations/Validations.json';
import {getToday} from 'shared/utils/dateUtils';
import moment from 'moment';
import Alarms from './Alarms';


export default function SearchAlarms() {
    const { Step } = Steps;
    const { RangePicker } = DatePicker;
    const { search } = useLocation()
    const queryParams = useMemo(() => new URLSearchParams(search), [search])
    const dateFormat = 'D/M/YYYY';
    const exportFormat = 'DD-MM-YYYY'
    const [disableTable, setDisableTable] = useState(true)
    const [endPoint, setEndPoint] = useState()
    const myRef = useRef();
    const history = useHistory();
    const [dates, setDates] = useState([]);
    const [hackValue, setHackValue] = useState();
    const [value, setValue] = useState();
    const defaultExportFilename = 'Anytime_BTMAlarmReport_'
    const [exportFilename, setExportFilename] = useState(`Anytime_BTMAlarmReport_${getToday().today}_${getToday().today}`)

    const executeScroll = () => myRef.current.scrollIntoView({ behavior: 'smooth' });

    const formItemLayout = {
        labelCol: {
            span: 12
        },
        wrapperCol: {
            span: 12
        },
    };

    const tailLayout = {
        wrapperCol: { offset: 8, span: 16 },
    };

   

    const onOpenChange = open => {
        if (open) {
            setHackValue([]);
            setDates([]);
        } else {
            setHackValue(undefined);
        }
    };


    const {
        form,
        current,
        gotoStep,
        stepsProps,
        formProps,
        submit,
        formLoading,
    } = useStepsForm({
        async submit(fieldsValues) {
            const { range } = fieldsValues;
            const values = {
                ...fieldsValues,
                'fromDate': range ? range[0]?.format(dateFormat) : null,
                'toDate': range ? range[1]?.format(dateFormat) : null,
                'channel': fieldsValues.channel !== 'ALL' ? fieldsValues.channel: null
            }
            Object.keys(values).forEach(key => values[key] === null || values[key] === undefined || values[key] === '' || key === 'range' ? delete values[key] : values[key]);
            const params = new URLSearchParams(values);
            history.replace({ search: `?${params}` });
            setEndPoint(`${EndPoints.REPORTS.GETALARMS}?${params}`);
            await new Promise(r => setTimeout(r, 1000));
            return 'ok';
        },
        total: 3,
    });

    const disabledDate = (curr) => disableSpecificDates(curr, dates,form?.getFieldValue('range'));
    const disableOnlyDatesAfterCurrent = (curr) => { if (form?.getFieldValue('range')) return true; return curr && curr > moment().endOf('day'); }
    useEffect(() => {
        const fromDateQueryParam =queryParams.get('fromDate')
        const toDateQueryParam =queryParams.get('toDate')
        const fromDateMomentFormatted= moment(fromDateQueryParam, dateFormat);
        const toDateMomentFormatted= moment(toDateQueryParam, dateFormat);
        const channelPrefix = queryParams.get('channel') === '1' ? 'AN_' : 'IM_'
        form.setFieldsValue({
            'policyNumber': queryParams.get('policyNumber'),
            'plateNumber': queryParams.get('plateNumber'),
            'range': (fromDateQueryParam && toDateQueryParam) ? [fromDateMomentFormatted, toDateMomentFormatted] : null,
            'channel':queryParams.get('channel') ? queryParams.get('channel'):'ALL'
        })
        setExportFilename(`${queryParams.get('channel') ? `${channelPrefix}${defaultExportFilename}` :defaultExportFilename }${fromDateQueryParam ? fromDateMomentFormatted?.format(exportFormat) : getToday().today}_${fromDateQueryParam ? toDateMomentFormatted?.format(exportFormat) : getToday().today}`)
        setEndPoint(`${EndPoints.REPORTS.GETALARMS}?${queryParams.toString()}`);
    }, [queryParams, form])


    const formList = [
        <>
            <Col span={8} >
                <Form.Item
                    label="Αριθμός Συμβολαίου:"
                    name="policyNumber"
                    rules={[{ pattern: new RegExp(Validations.POLICYNUMBER.REGEX), message: Validations.POLICYNUMBER.MESSAGE }]}
                >
                    <Input onChange={() => { form.setFieldsValue({ 'range': null }); form.setFieldsValue({ 'previousUpdate': false }) }} />
                </Form.Item>
            </Col>
            <Col span={8} >
                <Form.Item
                    label="Αριθμός Κυκλοφορίας:"
                    name="plateNumber"
                    rules={[{ pattern: new RegExp(Validations.PLATENUMBER.REGEX), message: Validations.PLATENUMBER.MESSAGE }]}
                >
                    <Input onChange={() => { form.setFieldsValue({ 'range': null }); form.setFieldsValue({ 'previousUpdate': false }) }} />
                </Form.Item>
            </Col>
            <Col span={8} >
                <Form.Item name="channel" label="Channel:" >
                    <Select defaultValue="ALL" options={[{value:'1', label:'Anytime'},{value:'2', label:'IM'},{value:'ALL', label:'ALL'}]} />
                </Form.Item>
            </Col>
            <Form.Item {...tailLayout}>
                <Button onClick={() => gotoStep(current + 1)}>Επόμενο</Button>
            </Form.Item>
        </>,
        <>
            <Col span={10} >
                <Form.Item name="range" label="Ημερομηνία Συμβάντος"  >
                    <RangePicker
                        format={dateFormat}
                        style={{ width: '150%' }}
                        value={hackValue || value}
                        disabledDate={(!form.getFieldValue('policyNumber') && !form.getFieldValue('plateNumber')) ? disabledDate : disableOnlyDatesAfterCurrent}
                        onCalendarChange={val => setDates(val)}
                        onChange={val => setValue(val)}
                        onOpenChange={onOpenChange} />
                </Form.Item>
            </Col>
            <Form.Item {...tailLayout}>
                <Button
                    style={{ marginRight: 10 }}
                    type="primary"
                    loading={formLoading}

                    onClick={() => {
                        if ((!form.getFieldValue('policyNumber') && !form.getFieldValue('plateNumber') && !form.getFieldValue('range'))) {
                            message.info('Πρέπει να συμπληρώσετε ημερομηνίες')
                        } else {
                            submit().then(result => {
                                if (result === 'ok') {
                                    gotoStep(current + 1);
                                    setDisableTable(false)
                                    executeScroll();
                                }
                            });
                        }
                    }}
                >
                    Αναζήτηση
                </Button>
                <Button onClick={() => gotoStep(current - 1)}>Προηγούμενο </Button>
            </Form.Item>
        </>
    ]


    return (
        <>
            <Card type="inner" headStyle={headerStyle} title="Συμπληρώστε οποιοδήποτε από τα πεδία και στη συνέχεια πατήστε το κουμπί Αναζήτηση" >
                <Row style={rowStyle}>
                    <Col style={{ color: 'black' }} span={24}>Κριτήρια Αναζήτησης</Col>
                </Row>
                <Steps  {...stepsProps} >
                    <Step disabled />
                    <Step disabled />
                    <Step disabled />
                </Steps>
                <Form
                    {...formItemLayout}
                    {...formProps}
                >
                    {formList[current]}
                </Form>
                {current === 2 && (
                    <Col span={12} >
                        <Form.Item {...tailLayout}>
                            <Button
                                type="primary"
                                onClick={() => {
                                    form.resetFields();
                                    gotoStep(0);
                                    setDisableTable(true)
                                    history.replace('/statistics/customer-reports/alarms')
                                }}
                            >
                                Αναζητείστε ξανά
                            </Button>
                        </Form.Item>
                    </Col>
                )}
            </Card>
            {disableTable === true ? null :
                <Col ref={myRef}>
                    <Alarms endPoint={endPoint} exportFilename={exportFilename} />
                </Col>}
        </>
    );
}